import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const CBHOFNE_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/cbhofne/logo.png",
        alt: "Capstone Behavioral Health Logo",
        style: { width: "300px", height: "100%", isMobile: { width: "200px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 25,
  state: "NE",
  departmentIds: [104, 106],
};
